import { client } from './apollo-client'
import * as mutations from './mutations'
import * as queries from './queries'

export { queries, mutations, client }
